import axios from 'axios';
// added comment to update codepipeline

export async function readHTML(input) {
  const response = await fetch(
    `${process.env.REACT_APP_API_KEY}/api/social-media/news`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        input: input
      }),
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Unknown error");
  }

  return data.html;
}
